import { Typography } from '@mui/material' ;
  
import React from 'react' 
 
const Marriages = () => { 
  return ( 
    <div> 
        <center> 
            <h1> 
                WEDDING
            </h1> 
        </center> 
        <h2>About Wedding</h2>
      <Typography variant="h5"> 
      A wedding is a marriage ceremony where legally or formally recognized union of two people as partners in a personal relationship. Wedding conventions and traditions shift incredibly between societies, ethnic gatherings, religions, nations, and social classes. Most wedding functions include a trade of marriage promises by the couple, introduction of a blessing offering, ring representative thing, blossoms, cash, and an open announcement of marriage by a specialist figure.

Extraordinary wedding articles of clothing are frequently worn, and the function is at times taken after by a wedding gathering. Music, petitions, readings or religious writings are likewise regularly consolidated into the service. We as a Wedding Planners make your dream come true by providing the best wedding event services with our highly professional Wedding Planners.
      </Typography>
      &nbsp;
      &nbsp;
      <div>

       <center>
        <h2>
        DECORS
        </h2>
        <div class="row row-cols-1 row-cols-md-3 g-4 containers">
  <div class="col">
    <div class="card h-100">
      <img src="./images/mi1.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Classic Mandapam Decor</h5>
        <p class="card-text">Authentic Sounth India Wedding</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/w13.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Destination wedding Decor</h5>
        <p class="card-text"> classic destination wedding</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img18.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Function Hall Decor</h5>
        <p class="card-text">Heavy asthetic south indian weddind decor</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
</div>
<div class="row row-cols-1 row-cols-md-3 g-4 containers">
  <div class="col">
    <div class="card h-100">
      <img src="./images/img19.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">simple decor at home </h5>
        <p class="card-text"> Home wedding</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img21.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Reception Decor</h5>
        <p class="card-text">Trendy Reception Decor</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img22.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Mehandhi event Decor</h5>
        <p class="card-text">Open space mehandhi decor</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="Deta">click to check out the details</a></small>
      </div>
    </div>
  </div>
</div>
&nbsp;
&nbsp;
&nbsp;
&nbsp;
<>
<div>
<h1 className='text-center mt-3'>PHOTO SHOOTS</h1>
&nbsp;
&nbsp;
 <div class="row row-cols-1 row-cols-md-3 g-4 container">
  <div class="col">
    <div class="card h-100">
      <img src="./images/img27.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Pre wedding shoot1</h5>
        <p class="card-text"> Studio Name: Digital Graphix   cell:08401273160 </p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img25.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Pre Shoot 2</h5>
        <p class="card-text"> Studio Name:Sudha Prography  cell:08401298586</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img26.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Pre Shoot-3</h5>
        <p class="card-text">Studio Name:Sreerasthu photography   cell:08401325241</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
</div>
<div class="row row-cols-1 row-cols-md-3 g-4 container">
  <div class="col">
    <div class="card h-100">
      <img src="./images/img28.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Photo Shoot-4 </h5>
        <p class="card-text">Studio name: Frist Snap Stories  cell:08401136401</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img29.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Photo Shoot-5</h5>
        <p class="card-text">Studio Name:Sapthapathi live Events  cell:09035479520</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card h-100">
      <img src="./images/img30.jpg" class="card-img-top" />
      <div class="card-body">
        <h5 class="card-title">Photo shoot-6</h5>
        <p class="card-text">Studio name:Abiba Events & Entertainments cell:08147674688</p>
      </div>
      <div class="card-footer">
        <small class="text-muted"><a href="">click to check out the details</a></small>
      </div>
    </div>
  </div>
  </div>
  </div>  

</>
   
 
   
 </center> 
    </div>
    </div> 
    
    
  ) 
} 
 
export default Marriages